// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import axios from 'axios'
import limit from './api/limit'
import store from './store'
import Print from 'vue-print-nb'
import 'element-ui/lib/theme-chalk/index.css'

Vue.config.productionTip = false
Vue.use(Print)
Vue.use(ElementUI, {size: 'small'}, axios)
Vue.prototype.$limit = limit
// Vue.prototype.$uploadUrl = 'https://gen.lexsvape.com:39000/attachment/upload/single'//测试
// Vue.prototype.$uploadUrl = 'https://f.laizao.cn:9000/attachment/upload/single'//生产

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js